import type * as lazyIndex from './lazyIndex';
import { LazyAction, LazyModule } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "AppHostState"*/ './lazyIndex'),
    { name: 'AppHostState' }
);

export const lazyInitializeSharePointSiteInfo: LazyAction<
    typeof lazyIndex.initializeSharePointSiteInfo,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.initializeSharePointSiteInfo);

export const lazyOpenAppStoreModal: LazyAction<
    typeof lazyIndex.openAppStoreModal,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.openAppStoreModal);
export const lazyCloseAppStoreModal: LazyAction<
    typeof lazyIndex.closeAppStoreModal,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.closeAppStoreModal);
export const lazyOnOpenAppAboutDialog: LazyAction<
    typeof lazyIndex.onOpenAppAboutDialog,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.onOpenAppAboutDialog);

export const lazyOnOpenPermissionsDialog: LazyAction<
    typeof lazyIndex.onOpenDevicePermissions,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.onOpenDevicePermissions);

export const lazyOnSavePermissions: LazyAction<
    typeof lazyIndex.onSaveDevicePermissions,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.onSaveDevicePermissions);

export function closeDetailsDialog(): void {
    lazyOnOpenAppAboutDialog.importAndExecute(undefined /* appId */);
}

export const lazyOpenLaunchPageMetaOsApp: LazyAction<
    typeof lazyIndex.openLaunchPageMetaOsApp,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.openLaunchPageMetaOsApp);
export const lazyFetchAndOpenLaunchPageMetaOsApp: LazyAction<
    typeof lazyIndex.fetchAndOpenLaunchPageMetaOsApp,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.fetchAndOpenLaunchPageMetaOsApp);
export const lazyOnOpenMetaOsAppFromComposeAppStore: LazyAction<
    typeof lazyIndex.onOpenMetaOsAppFromComposeAppStore,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.onOpenMetaOsAppFromComposeAppStore);
export const lazyOnInvalidAppNavigation: LazyAction<
    typeof lazyIndex.onInvalidAppNavigation,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.onInvalidAppNavigation);
export const lazyOnShowMessageExtensionAppInstalledDialog: LazyAction<
    typeof lazyIndex.onShowMessageExtensionAppInstalledDialog,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.onShowMessageExtensionAppInstalledDialog);
export const lazyOnMetaOsAppUninstalled: LazyAction<
    typeof lazyIndex.onMetaOsAppUninstalled,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.onMetaOsAppUninstalled);
export const lazyOnOpenAppUpgradeDialog: LazyAction<
    typeof lazyIndex.onOpenAppUpgradeDialog,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.onOpenAppUpgradeDialog);
export const lazyOnOpenAppStoreLaunchPage: LazyAction<
    typeof lazyIndex.onOpenAppStoreLaunchPage,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.onOpenAppStoreLaunchPage);
export const lazyDecodeLinkedEntity: LazyAction<
    typeof lazyIndex.decodeLinkedEntity,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.decodeLinkedEntity);
export const lazyAddProxyScriptToChildWindow: LazyAction<
    typeof lazyIndex.addProxyScriptToChildWindow,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.addProxyScriptToChildWindow);
